import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StoreImageModel, StoreModel, WorkTimeModel } from 'src/app/models/store/store.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../../../base-page';
import { createMask } from '@ngneat/input-mask';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'src/app/services/message.service';
import { CityModel } from 'src/app/models/store/city.model';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { parseDate, prepareDateToUtc } from 'src/app/helpers/date-time';

@Component({
  selector: 'app-store-main-info',
  templateUrl: './store-main-info.component.html',
  styleUrls: ['./store-main-info.component.scss'],
  standalone: false
})
export class StoreMainInfoComponent extends BasePage implements OnInit {

  @Input() storeId?: string;

  private mApiService = inject(ApiService);
  private mRouter = inject(Router);
  private mMessageService = inject(MessageService);

  public workTimes: {
    from: NgbTimeStruct,
    to: NgbTimeStruct
  }[] = [
      {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }, {
        from: { hour: 0, minute: 0, second: 0 },
        to: { hour: 0, minute: 0, second: 0 },
      }
    ]

  public selectedCloseDate?: NgbDateStruct;

  public model: StoreModel = {
    images: [],
    workTime: [],
    isEnabled: true,
  }

  public cities: CityModel[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.isBusy = true;
    let indicators = [1];

    if (this.storeId) {
      this.model.id = this.storeId;
      indicators.push(1);
      this.mApiService.get<StoreModel>(`/api/admin/store/${this.storeId}`).subscribe({
        next: r => {
          this.model = r;

          this.workTimes = this.model.workTime.map(x => { return { from: this.strToTime(x.from), to: this.strToTime(x.to) }; });

          if (r.closeDate) {
            this.selectedCloseDate = parseDate(r.closeDate);
          }

          this.isBusy = false;
          indicators.pop();
          this.isBusy = indicators.length > 0;
        }, error: () => {
          indicators.pop();
          this.isBusy = indicators.length > 0;
        }
      });
    }

    this.mApiService.getWithParams<{}, PagedResponseModel<CityModel>>('/api/admin/city/list', {
      page: 1,
      pageSize: 10000,
      search: {}
    }).subscribe({
      next: r => {
        this.cities = r.items;
        indicators.pop();
        this.isBusy = indicators.length > 0;
      }, error: () => {
        indicators.pop();
        this.isBusy = indicators.length > 0;
      }
    });
  }

  public phoneMask = createMask<string>('+9 999 999 9999');

  public save() {
    this.isBusy = true;

    this.model.workTime = this.workTimes.map(x => { return { from: this.timeToStr(x.from), to: this.timeToStr(x.to) } });

    if (this.selectedCloseDate) {
      this.model.closeDate = prepareDateToUtc(this.selectedCloseDate, { hour: 0, minute: 0, second: 0 });
    } else {
      this.model.closeDate = undefined;
    }

    this.mApiService.post<StoreModel, StoreModel>('/api/admin/store/', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/stores/list/edit/${r.id}`]);
        }

        this.workTimes = this.model.workTime.map(x => { return { from: this.strToTime(x.from), to: this.strToTime(x.to) }; });

        this.model = r;
        this.mMessageService.addMessage({ text: 'Магазин сохранен', type: this.mMessageService.types.success });
      }, error: () => this.isBusy = false
    });
  }

  public removeImage(image: StoreImageModel) {
    this.model.images?.splice(this.model.images?.indexOf(image), 1);
  }

  public moveImage(image: StoreImageModel, toLeft: boolean) {
    if (!this.model.images) {
      return;
    }

    let currentIndex = this.model.images.findIndex(x => x.id === image.id);

    let newIndex = currentIndex + (toLeft ? -1 : 1);

    if (newIndex < 0) {
      return;
    }

    if (newIndex >= this.model.images.length) {
      return;
    }

    const swap = this.model.images[newIndex];

    swap.order = currentIndex + 1;
    this.model.images[currentIndex].order = newIndex + 1;

    this.model.images[newIndex] = this.model.images[currentIndex];
    this.model.images[currentIndex] = swap;
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    formData.append('order', ((this.model.images?.length ?? 0) + 1).toString());
    this.isBusy = true;

    this.mApiService.formData<StoreImageModel>('/api/admin/store/image/save', formData).subscribe({
      next: (r: StoreImageModel) => {
        if (!this.model.images) {
          this.model.images = [];
        }

        this.model.images.push(r);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public getWeekdayName(index: number) {
    switch (index) {
      case 0:
        return 'ПН';
      case 1:
        return 'ВТ';
      case 2:
        return 'СР';
      case 3:
        return 'ЧТ';
      case 4:
        return 'ПТ';
      case 5:
        return 'СБ';
      case 6:
        return 'ВС';
    }
    return '';
  }

  public clickmap($event: any) {
    const coords = $event.event.get('coords') as Array<number>;
    this.model.location = {
      lat: coords[0],
      lon: coords[1]
    }
  }

  private strToTime(str: string): NgbTimeStruct {
    const parts = str.split(':');
    return {
      hour: parseInt(parts[0]),
      minute: parseInt(parts[1]),
      second: 0
    }
  }

  private timeToStr(time: NgbTimeStruct): string {
    return this.numDate(time.hour) + ':' + this.numDate(time.minute) + ':00.000';
  }

  private numDate(num: number) {
    return num < 10 ? '0' + num : num.toString();
  }
}
